export const BOARDS_ERROR_ANALYTICS = 'directories.boards.error' as const;
